import { fetchEndpointData } from '@utils/fetchEndpointData';

export interface FeatureFlag {
  id: string;
  enabled: boolean;
  description: string;
  updatedAt: string;
}

export async function fetchFeatureFlags(): Promise<FeatureFlag[]> {
  return fetchEndpointData<FeatureFlag[]>('/api/v1/feature-flags');
}

export async function updateFeatureFlag(id: string, enabled: boolean): Promise<FeatureFlag> {
  return fetchEndpointData<FeatureFlag>(`/api/v1/feature-flags/${id}`, {
    method: 'PUT',
    body: { enabled },
  });
}
